var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachedFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4567 6.6818H8.59295V3.81836H6.68376V6.6818H3.82031V8.591H6.68376V11.4548H8.59295V8.591H11.4567V6.6818ZM16.5475 6.6818H24.1839V8.591H16.5475V6.6818ZM5.61292 23.7382L7.638 21.7135L9.66309 23.7382L11.013 22.3886L8.98794 20.3639L11.013 18.3392L9.66309 16.9892L7.638 19.014L5.61292 16.9892L4.26333 18.3392L6.28807 20.3639L4.26333 22.3886L5.61292 23.7382Z",
    fill: "#1E4387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V28H16.5455V25.4546H15.2729V15.2729H25.4546V16.5455H28V0H0ZM2.54571 2.54571H12.7275V12.7275H2.54571V2.54571ZM12.7275 25.4546H2.54571V15.2729H12.7275V25.4546ZM25.4546 12.7275H15.2729V2.54571H25.4546V12.7275Z",
    fill: "#1E4387"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9258 19.3081V25.0646L22.9111 27.943L27.8963 25.0646V19.3081L22.9111 16.4297L17.9258 19.3081ZM25.0325 19.859L22.9107 21.0837L20.7892 19.859L22.9111 18.634L25.0325 19.859ZM19.835 21.5124L21.9565 22.7371V25.1871L19.835 23.9624V21.5124ZM23.8657 25.1874V22.7371L25.9875 21.5124V23.9624L23.8657 25.1874Z",
    fill: "#1E4387"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachedFile);
export default __webpack_public_path__ + "static/media/attached-file.8ca60130607d03a82cb298b8fd842708.svg";
export { ForwardRef as ReactComponent };